<template>
  <div class="py-8 tableWidth">
    <table cellspacing="0">
      <thead class="tableHeading">
        <tr>
          <th class="font-weight-medium">Type</th>
          <th class="font-weight-medium">Sender</th>
          <th class="font-weight-medium">Receiver</th>
          <th class="font-weight-medium">Amount</th>
          <th class="font-weight-medium">Fees</th>
          <th class="font-weight-medium">Date Created</th>
        </tr>
      </thead>
      <tbody v-for="(t, i) in transactions" :key="i">
        <tr class="text-center">
          <td>{{ t.transactionType }}</td>
          <td>{{ t.sender }}</td>
          <td>{{ t.receiver }}</td>
          <td>NGN {{ t.ammount.toLocaleString("en") }}</td>
          <td>NGN {{ t.fees.toLocaleString("en") }}</td>
          <td>{{ t.createdDate | dateFormatter }}</td>
        </tr>
      </tbody>
    </table>

    <div class="text-center">
      <div>
        <Pagination
          :page="page"
          :pagination="total"
          :number="1"
          @prevPagination="prevPagination"
          @nextPagination="nextPagination"
          @setPagination="setPagination"
        />
      </div>
    </div>
  </div>
</template>
    
    
    
    
    
<script>
import Vue from "vue";
import Pagination from "../Misc/Pagination.vue";
import { dateFormatter } from "@/utils/formatter";
Vue.filter("dateFormatter", dateFormatter);

export default {
  props: {
    total: {
      type: Number,
    },
    transactions: {
      type: Array,
    },
    page: {
      type: Number,
    },
  },

  components: {
    Pagination,
  },
  data() {
    return {
      showBalance: true,
    };
  },
  computed: {},

  methods: {
    prevPagination(e) {
      window.scrollTo(0, 0);
      if (e > 1) {
        this.$store.dispatch("payment/setPaymentPagination", e - 1);
      }
    },

    setPagination(e) {
      window.scrollTo(0, 0);
      this.$store.dispatch("payment/setPaymentPagination", e);
    },

    nextPagination(e) {
      window.scrollTo(0, 0);
      if (e < Math.floor(this.total / 10)) {
        this.$store.dispatch("payment/setPaymentPagination", e + 1);
      }
    },
  },
};
</script>
    
    <style scoped>
.tableWidth {
  overflow-x: auto;
}

.tableHeading {
  background: #f9fafb;
  width: 100%;
}
table {
  width: 100%;
}

.tableHeading tr {
  background: #f9fafb;
  border-radius: 20px;
}

td {
  border-bottom: 2px solid #f9fafb;
}
.tableHeading th {
  font-size: 14px;
  padding: 10px 10px !important;
  background: #f9fafb;
  text-align: start;
}

td {
  font-size: 14px;
  padding: 10px !important;
  text-align: start;
}

.active {
  color: #1c6bff;
}

.pending {
  color: #f59e0b;
}

.completed {
  color: #22c55e;
}

.v-date-picker-title,
.v-picker__title,
.v-date-picker-header {
  display: none !important;
}
.v-date-picker-title {
  color: pink !important;
}

@media screen and (min-width: 1300px) {
  .pickerStyle {
    width: 360px;
  }
}

.v-expansion-panel::before {
  box-shadow: none !important;
}

.v-pagination {
  background: red;
  box-shadow: none !important;
}
.border {
  outline: 30px !important;
  background: red;
}

.checkBoxPosition {
  margin: 0px 0px 0px 11px;
}
</style>
    